let opacityMap = {};
const optionProperties = ['shape3d', 'all', 'left', 'right', 'top', 'bottom', 'front', 'back', 'from', 'to'];
const nodeOpacity = 0.04;
export function saveNodeOpacity(dm, ignoreNode) {
    const opacity = nodeOpacity
    dm.each(function (d) {
        const id = d.getId()
        if (!opacityMap[id]) {
            opacityMap[id] = ht.Default.clone(d.getStyleMap())
        } else if (d === ignoreNode) {
            d.setStyleMap(ht.Default.clone(opacityMap[id]))
        }

        if (ht.Default.isArray(ignoreNode)) {
            if (ignoreNode.indexOf(d) >= 0) return
        }
        else if (d === ignoreNode) {
            return
        }

        optionProperties.forEach(k => {
            d.s(k + '.opacity', opacity)
            d.s(k + '.transparent', true)
        })

        d.s({
            '3d.selectable': false,
            batch: undefined,
        })
    })
}

export function restoreNodeOpacity(dm) {
    dm.each(d => {
        const style = opacityMap[d.getId()];
        d.setStyleMap(ht.Default.clone(style));
    });
}

/**
 * @description: 经纬度转换为3d坐标
 * @param {longitude,dimension,r} 经度 维度 地球模型半径
 * @return: [x,y,z] 3d坐标
 */
export function to3dPoint(longitude, dimension, r = 400) {
    let y = r * Math.sin((Math.PI / 180) * dimension);
    let temp = r * Math.cos((Math.PI / 180) * dimension);
    let x = temp * Math.sin((Math.PI / 180) * longitude);
    let z = temp * Math.cos((Math.PI / 180) * longitude);
    return [x, y, z];
}

export function formatDate(date, formatStr) {
    var str = formatStr;
    var Week = ['日', '一', '二', '三', '四', '五', '六'];

    str = str.replace(/yyyy|YYYY/, date.getFullYear());
    str = str.replace(/yy|YY/, (date.getYear() % 100) > 9 ? (date.getYear() % 100).toString() : '0' + (date.getYear() % 100));
    var month = date.getMonth() + 1;
    str = str.replace(/MM/, month > 9 ? month.toString() : '0' + month);
    str = str.replace(/M/g, month);

    str = str.replace(/w|W/g, Week[date.getDay()]);

    str = str.replace(/dd|DD/, date.getDate() > 9 ? date.getDate().toString() : '0' + date.getDate());
    str = str.replace(/d|D/g, date.getDate());

    var hour = date.getHours();
    str = str.replace(/HH/, hour > 9 ? hour.toString() : '0' + hour);
    str = str.replace(/H/g, hour);

    str = str.replace(/A/g, hour >= 12 ? 'PM' : 'AM');
    str = str.replace(/Aa/g, hour >= 12 ? 'pm' : 'am');

    hour = hour > 12 ? hour % 12 : hour;
    str = str.replace(/hh/, hour > 9 ? hour.toString() : '0' + hour);
    str = str.replace(/h/g, hour);

    str = str.replace(/mm/, date.getMinutes() > 9 ? date.getMinutes().toString() : '0' + date.getMinutes());
    str = str.replace(/m/g, date.getMinutes());
    str = str.replace(/ss|SS/, date.getSeconds() > 9 ? date.getSeconds().toString() : '0' + date.getSeconds());
    str = str.replace(/s|S/g, date.getSeconds());

    return str;
}

export const deserialize = (function () {
    let cacheMap = {};

    /**
     * 加载 json 并反序列化
     */
    return function (view, url, cb, notUseCache) {
        const cache = !notUseCache;

        let cacheContent;
        if (cache) cacheContent = cacheMap[url];

        // 不使用缓存，重新加载
        view.deserialize(cacheContent || url, (json, dm, view, list) => {
            if (!cacheContent) cacheMap[url] = json;

            if (ht.Default.isFunction(cb)) cb(json, dm, view, list, cache);
        });
    }
})();
export function isEmpty(obj) {
    return obj === null || obj === undefined;
}
export const random = function (min, max) {
    if (isEmpty(max)) {
        max = min;
        min = 0;
    }

    let range = max - min;
    return Math.random() * range + min;
}

/**
 * 数组对象的升降序
 * @param {*} propertyName 
 * @param {*} type 
 */
export function comprisonArrayObject(propertyName, type = 'asc') {
    return function (object1, object2) {
        let value1 = object1[propertyName];
        let value2 = object2[propertyName];
        return type === 'asc' ? (value1 - value2) : (value2 - value1);
    }
}

export const {
    isObject,
    isNumber,
    isString,
    isBoolean,
    isArray,
    isFunction,
    startAnim
} = ht.Default;

/**
 * @description 属性扩充合并
 * @param {Object} dest   - object to extend
 * @param  {...Object} src - sources
 * @returns {Object}
 */
export function extend(dest) { // (Object[, Object, ...]) ->
    for (let i = 1; i < arguments.length; i++) {
        const src = arguments[i];
        for (const k in src) {
            dest[k] = src[k];
        }
    }
    return dest;
}

/**
 * 获取节点的所有后代节点
 * @param {*} node 
 * @param {*} allNodes 
 * @returns 
 */
export function getAllChildNodes(node, allNodes = []) {
    if (node) {
        node.eachChild(n => {
            if (n.a('old.opacity') === undefined) {
                n.a('old.opacity', n.s('opacity'));
            }
            allNodes.push(n);
            if (n.getChildren().size()) {
                getAllChildNodes(n, allNodes);
            }
        });
    }

    return allNodes;
}

export function setBlockNodeOpacity(block, opacity) {
    block.eachChild(node => {
        if (node.getChildren().size()) {
            setBlockNodeOpacity(node, opacity);
        }
        else {
            node.s('opacity', opacity);
        }
    });
}

/**
 * 获取 url 参数值
 */
export function getParam(name) {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    const r = window.location.search.substring(1).match(reg);
    if (r != null)
        return decodeURIComponent(r[2]);
    return null;
}

/**
 * 判断是 3D 
 * @param view 
 * @returns 
 */
export function is3DView(view) {
    return view instanceof ht.graph3d.Graph3dView;
}